import { makeStyles, createStyles } from "@material-ui/core";


export default makeStyles((theme) =>
    createStyles({
        divider: {
            marginBottom: "1.25em",
        },

        // Help Tooltip
        helpActive: {
            borderRadius: "50%",
            boxSizing: "content-box",
            outline: `0.25em solid ${theme.palette.secondary.main}`,
        },
        helpClose: {
            "&:hover": {
                backgroundColor: "transparent",
            },
            position: "absolute",
            right: 8,
            top: 2,
        },
        helpTooltip: {
            backgroundColor: "white",
            borderRadius: "1em",
            boxShadow: theme.shadows[3],
            color: theme.palette.text.primary,
            padding: "1em 1.5em",
            "& p": {
                marginTop: "0.25em",
            },
            width: 220,
        },

        // Help Menu
        menu: {
            padding: "1em",
            width: "22em",
        },
        menuSection: {
            paddingBottom: "1em",
            lineHeight: 2,
        },
        menuHeader: {
            fontSize: "1.2rem",
            fontWeight: 700,
        },
        sectionHeader: {
            fontSize: "0.875rem",
            fontWeight: 700,
        },
    }),
);
